import auth from './modules/auth';
import oauth from './modules/oAuth';
import oauth2 from './modules/oAuth2';
import account from './modules/account';
import onboard from './modules/onBoard';
import fund from './modules/fund';
import toolkit from './modules/toolkit';
import wizard from '../../modules/wizard/router/routes';

import Form from '@/app/views/_dev/forms/Form.vue';
import Home from '@/app/views/Home.vue';
import Admin from '@/app/views/Admin.vue';

const ALLOW_WIZARD_PUBLIC = process.env.VUE_APP_ALLOW_WIZARD_PUBLIC;

const routes = [
  // Welcome
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: { requiresAuth: true, app: 'HOME', refreshAccount: true },
  },
  {
    path: '/admin',
    name: 'admin',
    component: Admin,
    meta: { requiresAuth: true, app: 'HOME', refreshAccount: true },
  },
  {
    path: '/invite',
    name: 'invite',
    component: () => import(/* webpackChunkName: "invite" */ '@/app/views/account/Invite.vue'),
    props: route => ({ action: route.query.action }),
    meta: {
      requiresAuth: true,
    },
  },
  onboard,
  account,
  fund,
  toolkit,
  // Form Testing
  {
    path: '/dev/form',
    name: 'form',
    component: Form,
    meta: { requiresAuth: true, isDev: true },
  },
  oauth,
  oauth2,
  auth,
  // Catch All - TODO: 404 Error Page
  {
    path: '*',
    name: 'catch',
    redirect: '/',
    meta: { requiresAuth: true },
  },
];

if (ALLOW_WIZARD_PUBLIC === 'true') {
  // Insert before auth routes
  routes.splice(1, 0, wizard);
}

export default routes;
